var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"clear my-navigate-button",on:{"click":_vm.click}},[_c('p',[_vm._v(_vm._s(_vm.buttonText))]),_c('img',{attrs:{"src":require("../../../assets/images/btn-next.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }